export const IIN_PATTERN = RegExp('^\\d{12}$');
export const BIN_PATTERN = RegExp('^\\d{12}$');
export const PHONE_PATTERN = RegExp('^77\\d{9}$');
export const PHONE_WITH_PLUS_PATTERN = RegExp('^\\+77\\d{9}$');
export const PHONE_WITH_OPTIONAL_PLUS_PATTERN = RegExp('^\\+?77\\d{9}$');
export const FULL_NAME_PATTERN = RegExp('^[a-zA-Zа-яА-Я-]+(?: [a-zA-Zа-яА-Я-]+){1,2}$');
